import { ArrowLeft, CircleCheck, Clock3 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useModalFocus } from "@/lib/useModalFocus";

export const SupportFirstReplyDialog = ({ busy, onStay, onInProgress, onCompleted }) => {
  const { dialogRef, onKeyDown } = useModalFocus(onStay, busy);
  return <div ref={dialogRef} onKeyDown={onKeyDown} tabIndex={-1}
       className="fixed inset-0 z-[100] bg-[#111]/60 flex items-center justify-center px-4 py-6"
       role="dialog" aria-modal="true" aria-labelledby="support-first-reply-title"
       data-testid="support-first-reply-modal">
    <div className="w-full max-w-md bg-[#FAF9F6] p-6 sm:p-8 shadow-2xl max-h-[90vh] overflow-y-auto">
      <p className="text-xs uppercase font-semibold text-[#8E6234] mb-2">Prima risposta</p>
      <h2 id="support-first-reply-title" className="font-serif text-2xl text-[#1A1A1A]" data-testid="support-first-reply-title">
        Aggiorna lo stato del ticket
      </h2>
      <p className="text-sm text-[#555] mt-3 leading-relaxed" data-testid="support-first-reply-description">
        Il ticket è ancora Aperto. Scegli il nuovo stato prima di inviare la risposta.
      </p>
      <div className="grid gap-2 mt-7">
        <Button type="button" onClick={onInProgress} disabled={busy}
                className="support-ux-choice--warning justify-start border rounded-sm min-h-11 gap-2"
                data-testid="support-first-reply-in-progress">
          <Clock3 className="w-4 h-4 shrink-0" />In lavorazione e invia
        </Button>
        <Button type="button" onClick={onCompleted} disabled={busy} variant="outline"
                className="support-ux-choice--completed justify-start border-2 rounded-sm min-h-11 gap-2"
                data-testid="support-first-reply-completed">
          <CircleCheck className="w-4 h-4 shrink-0" />Completato e invia
        </Button>
        <Button type="button" onClick={onStay} disabled={busy} variant="ghost"
                className="justify-start text-[#555] rounded-sm min-h-11 gap-2 mt-1"
                data-testid="support-first-reply-stay">
          <ArrowLeft className="w-4 h-4 shrink-0" />Torna al ticket
        </Button>
      </div>
    </div>
  </div>;
};